import { render, staticRenderFns } from "./configureDueDateDialog.vue?vue&type=template&id=e0ff11d6&scoped=true"
import script from "./configureDueDateDialog.vue?vue&type=script&lang=js"
export * from "./configureDueDateDialog.vue?vue&type=script&lang=js"
import style0 from "./configureDueDateDialog.vue?vue&type=style&index=0&id=e0ff11d6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0ff11d6",
  null
  
)

export default component.exports